export const validHours = (1000 * 60 * 60 * 22);
export const oneDay = (1000 * 60 * 60 * 24);
export const limitDownloadInvoices = 10000;
